import type { CSSProperties, ReactEventHandler } from 'react'
import Image from 'next/image'

export interface NextImageWrapperProps {
  src: string
  alt: string
  className?: string
  style?: CSSProperties
  sizes?: string
  width?: number
  height?: number
  priority?: boolean
  fill?: boolean
  quality?: number
  onLoad?: ReactEventHandler<HTMLImageElement>
  onError?: ReactEventHandler<HTMLImageElement>
  'aria-hidden'?: boolean
}

export function NextImageWrapper({
  src,
  alt,
  className,
  style,
  sizes = '100vw',
  priority = false,
  fill,
  quality = 85,
  width,
  height,
  onLoad,
  onError,
  'aria-hidden': ariaHidden,
}: NextImageWrapperProps) {
  const hasDimensions = typeof width === 'number' && typeof height === 'number'
  const resolvedFill = fill ?? !hasDimensions
  const resolvedWidth = resolvedFill ? undefined : width
  const resolvedHeight = resolvedFill ? undefined : height

  return (
    <Image
      src={src}
      alt={alt}
      fill={resolvedFill}
      width={resolvedWidth}
      height={resolvedHeight}
      className={className}
      style={style}
      sizes={sizes}
      priority={priority}
      quality={quality}
      onLoad={onLoad}
      onError={onError}
      aria-hidden={ariaHidden}
    />
  )
}
